import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Loader2, Lock } from "lucide-react";
import { api, IMAGES, formatApiError } from "../lib/api";
import { EASE } from "../components/motion";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("nadou_token", data.token);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err, "Connexion impossible"));
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full bg-white border border-taupe/30 rounded-md px-4 py-3.5 text-sm text-espresso placeholder:text-espresso/40 focus:outline-none focus:ring-1 focus:ring-taupe transition-shadow duration-300";

  return (
    <div className="min-h-screen bg-cream grain-overlay flex items-center justify-center px-6" data-testid="admin-login-page">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: EASE }}
        className="w-full max-w-md bg-white border border-taupe/20 rounded-3xl p-10 shadow-[0_8px_30px_rgba(44,36,27,0.06)]"
      >
        <img src={IMAGES.logo} alt="Nadou Skin" className="h-10 w-auto mix-blend-multiply" />
        <h1 className="font-display text-3xl text-espresso mt-6">Espace pro</h1>
        <p className="text-sm text-espresso/55 font-light mt-2">Gérez vos rendez-vous, votre planning et vos tarifs.</p>
        <form onSubmit={submit} className="mt-8 space-y-4">
          <input
            data-testid="admin-email-input"
            type="email"
            required
            className={inputCls}
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <input
            data-testid="admin-password-input"
            type="password"
            required
            className={inputCls}
            placeholder="Mot de passe"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          {error && (
            <p className="text-sm text-[#9E4747]" data-testid="admin-login-error">{error}</p>
          )}
          <button
            data-testid="admin-login-submit"
            type="submit"
            disabled={loading}
            className="w-full rounded-full bg-espresso text-cream px-6 py-4 text-sm tracking-[0.12em] uppercase hover:bg-taupe transition-colors duration-300 disabled:opacity-50 inline-flex items-center justify-center gap-2"
          >
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Lock className="w-4 h-4" strokeWidth={1.5} />}
            Se connecter
          </button>
        </form>
        <a href="/" className="block mt-6 text-xs tracking-[0.14em] uppercase text-espresso/45 hover:text-espresso transition-colors duration-300">
          ← Retour au site
        </a>
      </motion.div>
    </div>
  );
}
